const enter = ['buy', 'sell']
const close = ['close']
const stop = ['stop']
const trail = ['trail']

const enter_size = [
    '100k unit',
    '10k unit',
    '1 lot',
    '0.5 lot',
    '50% lot',
    '2%',
    '2% balance',
    '2% bala',
    '2% equity',
    '2% equi',
    '100 usd',
    '100$',
]
const close_size = [
    '0.5 lot',
    '1k units',
    '50 usd',
    '50$',
    '30% profit',
    '50% amount'
]
const stop_size = [
    '1.222',
    '100 pips',
    '50 usd',
    '50$',
    '30% profit'
]
const trail_size = [
    '1.222',
    '100 pips',
    '50 usd',
    '50$',
    '30% profit'
]
const sl = [
    'sl@1.111',
    'sl=1.111',
    'sl=50 pips',
    'sl=100 usd',
]
const tp = [
    'tp@1.111',
    'tp=1.111',
    'tp=50 pips',
    'tp=100 usd',
    ''
]
const filter = [
    'filter = 2 last',
    'filter = 2 first'
]
const tag = [
    'tag = "pin bar, MACD"',
    'tag = priority_1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
]
const note = [
    'note = "new idea" ',
    'note = "new strategy"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
]
const instrument = [
    "AUDCAD :",
    "AUDJPY :",
    "AUDNZD :",
    "AUDUSD :",
    "CADJPY :",
    "EURAUD :",
    "EURCAD :",
    "EURCHF :",
    "EURCZK :",
    "EURGBP :",
    "EURJPY :",
    "EURUSD :",
    "GBPJPY :",
    "GBPUSD :",
    "NZDUSD :",
    "USDCAD :",
    "USDCHF :",
    "USDJPY :",
    "XAGUSD :",
    "XAUUSD :"
]



const enters = ''.concat(
    instrument[getRandom(len(instrument))], ' ',
    enter[getRandom(len(enter))], ' ',
    enter_size[getRandom(len(enter_size))], ' ',
    sl[getRandom(len(sl))], ' ',
    tp[getRandom(len(tp))], ' ',
    tag[getRandom(len(tag))], ' ',
    note[getRandom(len(note))]
)

const stops = ''.concat(
    instrument[getRandom(len(instrument))], ' ',
    stop[getRandom(len(stop))], ' ',
    stop_size[getRandom(len(stop_size))], ' ',
    filter[getRandom(len(filter))],
)
const closes = ''.concat(
    instrument[getRandom(len(instrument))], ' ',
    close[getRandom(len(close))], ' ',
    close_size[getRandom(len(close_size))], ' ',
    filter[getRandom(len(filter))],
)
const trails = ''.concat(
    instrument[getRandom(len(instrument))], ' ',
    trail[getRandom(len(trail))], ' ',
    trail_size[getRandom(len(trail_size))],
)



function getRandom(max) {
    return Math.floor(Math.random() * max)
}
function len(v) {
    return v.length
}
function getTemplate() {
    const templates = []
    for (let i = 0; i <= 20; i++) {
        templates.push(enters)
        templates.push(stops)
        templates.push(closes)
        templates.push(trails)
    }
    return templates
}

export default getTemplate